import WorkoutPlan from '../../images/health-content/workout-plan.png';
import rightArrow from '../../images/lab-test/rightArrow.svg';

const StartWorkoutPlanBanner = ({ onClick }) => {
  return (
    <div className="m-4 rounded-20 border bg-primary text-txtlight text-body-l font-semibold p-4 mb-16px">
      <div className="flex justify-between">
        <div className="flex-1 w-1/2">
          <div className="flex flex-col text-title-m2 font-bold mb-2">
            <span>Personalise your</span>
            <span>workout plan</span>
          </div>
          <div className="text-body-s font-regular flex flex-col ">
            <span>And track your</span>
            <span>everyday progress</span>
          </div>
        </div>
        <div className="w-1/2 pl-16px flex justify-center items-center">
          <img src={WorkoutPlan} alt="workout-plan" className="h-28" />
        </div>
      </div>
      <button
        className="w-full text-txtlight flex items-center justify-center gap-2 bg-textbox rounded-12 px-4 py-3 mt-16px clickable"
        onClick={onClick}
      >
        Get Started
        <span className="rounded-full w-4 h-4 bg-primary flex items-center justify-center">
          <img src={rightArrow} alt="right-arrow" className="w-1.5" />
        </span>
      </button>
    </div>
  );
};

export default StartWorkoutPlanBanner;
